export { default } from './QuestionComponent';
